// Doctor name helpers.
// Backend stores Doctor.name stripped of any "Dr." prefix and Title-cased
// (e.g. "John Smith"). The "Dr." honorific is a UI concern, rendered only
// when the current tenant's industry is hospital-like.

const HOSPITAL_KEYWORDS = ['hospital', 'clinic', 'homeo', 'health', 'medical', 'pharma'];

export function shouldPrefixDr(industryName) {
  if (!industryName) return false;
  const lower = String(industryName).toLowerCase();
  return HOSPITAL_KEYWORDS.some((kw) => lower.includes(kw));
}

export function getCurrentIndustry() {
  try {
    const u = JSON.parse(localStorage.getItem('userData') || '{}');
    return u.industry_name || '';
  } catch {
    return '';
  }
}

/** Strip any accidental "Dr." prefix from a stored name before rendering. */
export function stripDrPrefix(name) {
  if (!name) return '';
  return String(name).replace(/^\s*dr\.?\s+/i, '').trim();
}

/**
 * Format a doctor's name for display. Prepends "Dr. " when the tenant is a
 * hospital-industry company; otherwise returns the bare name.
 *
 *   formatDoctorName('John Smith', 'Hospital')   // "Dr. John Smith"
 *   formatDoctorName('John Smith', 'Restaurant') // "John Smith"
 */
export function formatDoctorName(name, industryName = getCurrentIndustry()) {
  const clean = stripDrPrefix(name);
  if (!clean) return '';
  return shouldPrefixDr(industryName) ? `Dr. ${clean}` : clean;
}
